Vue.asyncComponent('cms-dashboard-editor-side-bar', {
    props: {
        dataProvider: {
            type: Object,
            required: true
        },
    },
    computed: {
        /**
         * Editor context.
         */
        editorContext() {
            return this.dataProvider?.getEditorContext
                ? this.dataProvider.getEditorContext()
                : null;
        }
    },
}, 'cms/dashboard/editor/cms-dashboard-editor-side-bar.html');
